var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiRecommendations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n        stroke: currentColor;\n        stroke-linejoin: round;\n        stroke-width: .32px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.44,8.08c1.2,1.24,4.46,1.65,4.46,1.65,0,0-3.01.25-4.46,1.65s-1.65,4.46-1.65,4.46c0,0-.45-3.22-1.65-4.46s-4.46-1.65-4.46-1.65c0,0,3.42-.45,4.46-1.65s1.65-4.46,1.65-4.46c0,0,.45,3.22,1.65,4.46h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.17,2.59c.64.66,2.38.88,2.38.88,0,0-1.61.13-2.38.88s-.88,2.38-.88,2.38c0,0-.24-1.71-.88-2.38s-2.38-.88-2.38-.88c0,0,1.82-.24,2.38-.88s.88-2.38.88-2.38c0,0,.24,1.71.88,2.38Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiRecommendations);
export default __webpack_public_path__ + "static/media/ai-recommendations.dc073122e85ce4ecf066076b5270ec65.svg";
export { ForwardRef as ReactComponent };